// node modules
import * as React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Menu, Row, Col } from "antd";
import { useTranslation } from 'react-i18next';
import {
  BranchesOutlined,
  TeamOutlined,
  ApartmentOutlined,
  UserOutlined,
  BarChartOutlined
} from "@ant-design/icons";
import emitter from "../../utils/emitter";
// icons
import Dashboard from "assets/icons/Dashboard";
import Subscriptions from "assets/icons/Subscriptions";
import Faq from "assets/icons/Faq";
import Privacy from "assets/icons/Privacy";
import DataDeletion from "assets/icons/DataDeletion";
// texts
// styles
import "styles/sidebar.css";

const SidebarMenuComponent = ({ userInfo, className }) => {
  const [organizationDeleted, setOrganizationDeleted] = React.useState(false);
  const history = useHistory();
  const pathName = history.location.pathname;
  const { t } = useTranslation();

  // Hide organization link on the sidebar menu when organization is deleted
  React.useEffect(() => {
    emitter.on('ORGANIZATION_DELETED', () => {
      setOrganizationDeleted(true);
    });
  }, []);

  return (
    <Menu
      mode="inline"
      selectedKeys={[history.location.pathname]}
      className={className}
    >
      {/**************************************************** DEVICES PART ****************************************************/}
      <Menu.Item key={`/devices`} className="sidebar-menu">
        <NavLink
          exact
          to={`/devices`}
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <Dashboard />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('DEVICES')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
      {/********************************************** ORGANIZATIONS PART ********************************************/}
      {(userInfo.is_org_admin && !organizationDeleted) && (
        <Menu.Item key={`/organizations`} className="sidebar-menu">
          <NavLink
            exact
            to={`/organizations`}
            activeClassName='sidebar-active-menu-item'
          >
            <Row align="middle">
              <Col span='7' className="sidebar-icon-col">
                <ApartmentOutlined />
              </Col>
              <Col
								span='17'
								className='sidebar-text-column'
							>
                <span
                  className='sidebar-item-text'
                >
                  {t('ORGANIZATIONS')}
                </span>
              </Col>
            </Row>
          </NavLink>
        </Menu.Item>
      )}
      {/**************************************************** SUBSCRIPTIONS PART ****************************************************/}
      <Menu.Item key={`/subscriptions`} className="sidebar-menu">
        <NavLink
          exact
          to={`/subscriptions`}
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <Subscriptions />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('SUBSCRIPTIONS')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
      {/**************************************************** UPGRADE HARDWARE PART ****************************************************/}
      {userInfo.role === "admin" && (
        <Menu.Item key={`/upgrade-hardware`} className="sidebar-menu">
          <NavLink
            exact
            to={`/upgrade-hardware`}
            activeClassName='sidebar-active-menu-item'
          >
            <Row align="middle">
              <Col span='7' className="sidebar-icon-col">
                <BranchesOutlined />
              </Col>
              <Col
								span='17'
								className='sidebar-text-column'
							>
                <span
                  className='sidebar-item-text'
                >
                  {t('UPGRADE_HARDWARE')}
                </span>
              </Col>
            </Row>
          </NavLink>
        </Menu.Item>
      )}
      {/**************************************************** USER MANAGEMENT PART ****************************************************/}
      {userInfo.role === "admin" && (
        <Menu.Item key={`/users-management`} className="sidebar-menu">
          <NavLink
            exact
            to={`/users-management`}
            activeClassName='sidebar-active-menu-item'
          >
            <Row align="middle">
              <Col span='7' className="sidebar-icon-col">
                <TeamOutlined />
              </Col>
              <Col
								span='17'
								className='sidebar-text-column'
							>
                <span
                  className='sidebar-item-text'
                >
                  {t('USERS_MANAGEMENT')}
                </span>
              </Col>
            </Row>
          </NavLink>
        </Menu.Item>
      )}
      {/**************************************************** ADMIN ANALYTICS PART ****************************************************/}
      {userInfo.role === "admin" && (
        <Menu.Item key={`/admin-analytics`} className="sidebar-menu">
          <NavLink
            exact
            to={`/admin-analytics`}
            activeClassName='sidebar-active-menu-item'
          >
            <Row align="middle">
              <Col span='7' className="sidebar-icon-col">
                <BarChartOutlined />
              </Col>
              <Col
								span='17'
								className='sidebar-text-column'
							>
                <span
                  className='sidebar-item-text'
                >
                  {t('ADMIN_ANALYTICS')}
                </span>
              </Col>
            </Row>
          </NavLink>
        </Menu.Item>
      )}
      {/**************************************************** FAQ PART ****************************************************/}
      <Menu.Item key={`/faq`} className="sidebar-menu">
        <NavLink
          exact
          to={`/faq`}
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <Faq />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('FAQ')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
      {/******************************************************privacy and policies********************************* */}
      <Menu.Item key={`/privacy_policy`} className="sidebar-menu">
        <NavLink
          exact
          to={`/privacy`}
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <Privacy />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('PRIVACY_AND_POLICIES')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
      {/******************************************************data deletion part********************************* */}
      <Menu.Item key={`/data-deletion-instructions`} className="sidebar-menu">
        <NavLink
          exact
          to={`/account_deletion`}
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <DataDeletion />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('ACCOUNT_DELETION')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
      {/**************************************************** ACCOUNT SETTINGS PART ****************************************************/}
      <Menu.Item key="/account" className="sidebar-menu">
        <NavLink
          exact
          to="/account"
          activeClassName='sidebar-active-menu-item'
        >
          <Row align="middle">
            <Col span='7' className="sidebar-icon-col">
              <UserOutlined />
            </Col>
            <Col
							span='17'
							className='sidebar-text-column'
						>
              <span
                className='sidebar-item-text'
              >
                {t('ACCOUNT')}
              </span>
            </Col>
          </Row>
        </NavLink>
      </Menu.Item>
    </Menu>
  );
};

export default SidebarMenuComponent;
